module.exports = __webpack_public_path__ + "img/34.8831b037.png";